import React from 'react';
import cx from 'classnames';
import { Icon } from '../Icon/index.js';
import styles from './index.module.scss.js';

const Button = ({
  className,
  style,
  icon,
  title,
  isActive = false,
  onClick,
  size,
  isActiveRectFill
}) => /* @__PURE__ */ React.createElement(
  "button",
  {
    className: cx(styles.box, className, {
      [styles.active]: !isActiveRectFill && isActive,
      [styles[size || ""]]: !!size,
      [styles.isActiveRectFill]: isActiveRectFill
    }),
    style,
    onClick,
    "data-active": isActive,
    type: "button"
  },
  /* @__PURE__ */ React.createElement("span", { className: styles["icon-container"], "aria-hidden": true }, /* @__PURE__ */ React.createElement(Icon, { icon })),
  /* @__PURE__ */ React.createElement("span", { className: styles.title }, title)
);

export { Button };
//# sourceMappingURL=index.js.map
